import React from 'react';
import {
    FiBarChart2,
    FiCalendar,
    FiChevronLeft,
    FiChevronRight,
    FiFileText,
    FiHome,
    FiMessageSquare,
    FiUser,
    FiUsers,
    FiX
} from 'react-icons/fi';
import { NavLink } from 'react-router-dom';
import './Sidebar.css';

const Sidebar = ({ isOpen, onClose, isCollapsed, onToggleCollapse, userRole, isDesktop }) => {
  const role = (userRole || '').toLowerCase();
  const isAdmin = role === 'admin';
  const isEngineer = role === 'engineer';
  const isAreaHead = role === 'area_head';
  const isMobile = !isDesktop;

  const adminMenuItems = [
    { path: '/admin/dashboard', icon: FiHome, label: 'Dashboard' },
    { path: '/admin/tickets', icon: FiMessageSquare, label: 'All Tickets' },
    { path: '/admin/users', icon: FiUsers, label: 'Users' },
    { path: '/admin/visits', icon: FiCalendar, label: 'AMC Visits' },
    { path: '/admin/analytics', icon: FiBarChart2, label: 'Analytics' },
    { path: '/admin/profile', icon: FiUser, label: 'Profile' },
  ];

  const engineerMenuItems = [
    { path: '/engineer/dashboard', icon: FiHome, label: 'Dashboard' },
    { path: '/engineer/tickets', icon: FiMessageSquare, label: 'Tickets' },
    { path: '/engineer/visits', icon: FiCalendar, label: 'My Visits' },
    { path: '/engineer/profile', icon: FiUser, label: 'Profile' },
  ];

  const userMenuItems = [
    { path: '/user/dashboard', icon: FiHome, label: 'Dashboard' },
    { path: '/user/history', icon: FiFileText, label: 'History' },
    { path: '/user/new-ticket', icon: FiFileText, label: 'New Ticket' },
    { path: '/user/tickets', icon: FiMessageSquare, label: 'My Tickets' },
    { path: '/user/notifications', icon: FiMessageSquare, label: 'Notifications' },
    { path: '/user/account', icon: FiUsers, label: 'Account' },
  ];

  const areaHeadMenuItems = [
    { path: '/area-head/dashboard', icon: FiHome, label: 'Dashboard' },
    { path: '/area-head/tickets', icon: FiMessageSquare, label: 'Tickets' },
    { path: '/area-head/visits', icon: FiCalendar, label: 'AMC Visits' },
    { path: '/area-head/profile', icon: FiUser, label: 'Profile' },
  ];

  const menuItems = isAdmin ? adminMenuItems : isEngineer ? engineerMenuItems : isAreaHead ? areaHeadMenuItems : userMenuItems;

  return (
    <>
      {isOpen && isMobile && <div className="sidebar-overlay" onClick={onClose} />}
      <aside className={`sidebar ${isOpen ? 'open' : ''} ${isCollapsed && !isMobile ? 'collapsed' : ''}`}>
        <div className="sidebar-header">
          {!isCollapsed && <h2>Menu</h2>}
          <div className="sidebar-header-actions">
            {!isMobile && (
              <button className="collapse-btn" onClick={onToggleCollapse} title={isCollapsed ? 'Expand Menu' : 'Collapse Menu'}>
                {isCollapsed ? <FiChevronRight /> : <FiChevronLeft />}
              </button>
            )}
            {isMobile && (
              <button className="close-btn" onClick={onClose}>
                <FiX />
              </button>
            )}
          </div>
        </div>
        <nav className="sidebar-nav">
          {menuItems.map((item) => {
            const Icon = item.icon;
            return (
              <NavLink
                key={item.path}
                to={item.path}
                className={({ isActive }) =>
                  `nav-item ${isActive ? 'active' : ''}`
                }
                onClick={isMobile ? onClose : undefined}
                title={isCollapsed && !isMobile ? item.label : ''}
              >
                <Icon className="nav-icon" />
                {(!isCollapsed || isMobile) && <span className="nav-label">{item.label}</span>}
              </NavLink>
            );
          })}
        </nav>
      </aside>
    </>
  );
};

export default Sidebar;

